import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/company/members/groups/add-group')({
  beforeLoad: async () => {
    return redirect({ to: '/company/groups/add' })
  },
})
